import { setupOTelSDK } from '@cof/opentelemetry-instrumentation-rum';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './index.scss';
import { getOtelAppEnvironment, getOtelGatewayBase } from './utils/otelEnvironment';

const appEnvironment = getOtelAppEnvironment(window.location.host);
const gatewayBase = getOtelGatewayBase(appEnvironment);

try {
  setupOTelSDK({
    asv: 'ASVAIRKEYINTERNAL',
    ba: 'BAAirKeyInternal',
    component: 'WebNfcExtSite',
    otelServiceName: `airkey-web-nfc-site-${appEnvironment}`,
    overrides: {
      otelMetricsUrl: `${gatewayBase}/v1/metrics`,
      otelTracesUrl: `${gatewayBase}/v1/traces`,
      customResources: {
        TRACES_TARGET: 'card',
        METRICS_TARGET: 'card',
        'c1.instrumentation.type': 'browser',
      },
    },
  });
} catch (error) {
  console.error('OTel RUM initialization failed:', error);
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <App />,
);
